import React, { useState, FunctionComponent } from 'react'

import classNames from 'classnames'

import ToolbarIcon from './toolbaricon'
import Icon from 'components/shared/Icon'

const SideToolbarExtras: FunctionComponent<SideToolbarExtrasProps> = ({ show, editorState, onToggle, blockTypes }) => {
  const selection = editorState.getSelection()
  const blockType = editorState.getCurrentContent()
    .getBlockForKey(selection.getStartKey())
    .getType()

  return (
    <div className={classNames('toolbar side', { active: show })}>
      <ul className='toolbar-icons'>
        <li className='toolbar-static'>
          <Icon name='icon-menu' className='w8 h2 mh2 pointer' />
        </li>
        {blockTypes.map(type =>
          <ToolbarIcon
            key={type.label || type.icon}
            active={type.style === blockType}
            label={type.label}
            icon={type.icon}
            onToggle={onToggle}
            style={type.style}
          />
        )}
      </ul>
    </div>
  )
}

const SideToolBar: FunctionComponent<SideToolBarProps> = ({ editorState, onToggle, style, blockTypes }) => {
  const [expanded, setExpanded] = useState(false)
  return (
    <div
      style={style} className='side-toolbar'
      onMouseEnter={() => setExpanded(true)}
      onMouseDown={(e) => e.preventDefault()}
      onMouseLeave={() => setExpanded(false)}
    >
      <SideToolbarExtras show={expanded} editorState={editorState} onToggle={onToggle} blockTypes={blockTypes} />
      <Icon name='icon-menu' className='w7 valign-middle mh2 top1 grey' />
    </div>
  )
}

interface BlockType {
  icon: string;
  style: string;
  label: string;
}

interface CommonProps {
  editorState: any;
  onToggle: () => void;
  blockTypes: BlockType[];
}

interface SideToolBarProps extends CommonProps{
  style: React.CSSProperties;
}

interface SideToolbarExtrasProps extends CommonProps{
  show: boolean;
}


export default SideToolBar
